export default "__VITE_ASSET__4751c0bf__"